/**
 * @ngdoc service
 * @name ims.shared.data.service:assetTypeCollection
 * @description
 * A collection of ims AssetType objects. It handles loading and refreshing data.
 *
 */

import ImsObjectCollection from './ims_object_collection.service';
import { AssetType } from './asset_type';
import { AssetTypeResource } from '../resources';
import * as _ from 'lodash';
import { IIntervalService } from 'angular';
import { StartupRegistry } from 'app/startup/registry/registry';
import { ILocalStorageService } from 'angular-local-storage';
import { AssetTypeResourceType } from 'app/agriculture/contexts/RequiredStartupProviders/ServiceBlocking/assetTypeSchema';

function convertAssetTypeArrayToAssetTypeRecord(
    assetTypes: AssetTypeResourceType[],
): Record<number, AssetType> {
    const record: Record<number, AssetType> = {};

    assetTypes.forEach((assetType) => {
        record[assetType.id] = new AssetType(assetType);
    });

    return record;
}

/**
 * @ngdoc event
 * @name ims.shared.data.service:assetTypeCollection#AssetTypeCollection:Changed
 * @eventOf ims.shared.data.service:assetTypeCollection
 * @eventType emit on root scope
 * @description
 * Emitted when the AssetTypeCollection is changed/updated.
 *
 * @param {Object} angularEvent Synthetic event object.
 */

export class AssetTypeCollection extends ImsObjectCollection<AssetType> {
    constructor(
        startUpRegistry: StartupRegistry,
        localStorageService: ILocalStorageService,
        $interval: IIntervalService,
    ) {
        super(startUpRegistry, localStorageService, $interval, AssetTypeResource, AssetType);
    }

    getAllSelectable() {
        return _.pickBy(this.all, { selectable: true });
    }

    getAllSelectableAsArray() {
        return _.filter(this.getAllAsArray(), { selectable: true });
    }

    public shoveAssetTypesIntoCollection(stuff: AssetTypeResourceType[]) {
        this.all = convertAssetTypeArrayToAssetTypeRecord(stuff);
    }
}
